<template>
  <div id="app">
    <component :is="layout" />
    <vue-progress-bar />
    <div class="container">
      <router-view />
    </div>
    <my-footer />
    <my-navs />
  </div>
</template>

<script>
import "@/assets/css/font-awesome.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap-grid.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/css/phongthuy2.css";
import "@/assets/css/responsive2.css";

import header from "./components/common/header";
import footer from "./components/common/footer";
import navs from "./components/common/navs";

import "bootstrap/dist/js/bootstrap.js";
import "bootstrap/dist/js/bootstrap.bundle.js";

const default_layout = "no-search-header";
export default {
  name: "App",
  components: {
    "my-header": header,
    "my-footer": footer,
    "my-navs": navs,
  }, // id of the layout (required)
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    }
  }
};
</script>

<style lang="scss" scoped>
/* your style */
#app {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue